"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTextLength = void 0;
function validateTextLength(spec, text) {
  var asciiOnly = true;
  for (var i = 0; i < text.length; i++) {
    if (text.charCodeAt(i) > 127) {
      asciiOnly = false;
      break;
    }
  }
  if (asciiOnly) {
    return spec.ascii.min <= text.length && text.length <= spec.ascii.max;
  } else {
    return spec.unicode.min <= text.length && text.length <= spec.unicode.max;
  }
}
exports.validateTextLength = validateTextLength;